import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import 'normalize.css';
import './index.css';

import Footer from './footer';
import Header from './header';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      defaultTitle="Legacy of the Stars"
      titleTemplate="Legacy of the Stars—%s"
    >
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
    <Header />
    <div id="header-fade" />
    <div id="content" className="content">
      {children()}
    </div>
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js